<template>
  <div>
    <v-speed-dial
      fixed
      v-model="bulkEditShow"
      bottom
      right
      direction="left"
      :open-on-hover="false"
      transition="slide-x-transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="bulkEditShow"
          color="primary"
          dark
          fab
          :loading="apiCallPending"
        >
          <v-icon>edit</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <v-btn
        dark
        small
        :loading="apiCallPending"
        color="green"
        @click.prevent="publish"
      >
        Publish
      </v-btn>
      <v-btn
        dark
        small
        :loading="apiCallPending"
        color="red"
        @click.prevent="unpublish"
      >
        Unpublish
      </v-btn>
      <v-dialog
        v-model="bulkAssignDialog"
        max-width="350"
      >
        <v-btn
          slot='activator'
          dark
          small
          :loading="apiCallPending"
          color="primary"
        >
          Assign
        </v-btn>

        <v-card>
          <v-card-title>Assign Employee</v-card-title>
          <v-card-text>
            <v-autocomplete
              label="Employee"
              :items="assignableEmployees"
              item-text="name"
              item-value="id"
              v-model="assignedEmployee"
              :loading="employeesLoading"
              :disabled="employeesLoading"
              clearable
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" flat @click="bulkAssignDialog = false">Nevermind</v-btn>
            <v-btn color='success' small :loading="apiCallPending" @click="assignEmployee" :disabled="!assignedEmployee">
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn
        dark
        small
        :loading="apiCallPending"
        color="red"
        @click.prevent="unassignEmployee"
      >
        Unassign
      </v-btn>
    </v-speed-dial>
  </div>

</template>

<script>
import collectionApi from '@/api/collections'

export default {
  props: [ 'shifts' ],

  data() {
    return {
      bulkEditShow: false,
      apiCallPending: false,
      bulkAssignDialog: false,
      assignedEmployee: null,
      assignableEmployees: [],
      employeesLoading: false,
    }
  },

  created() {
  },

  watch: {
    bulkAssignDialog(val) {
      if (val && this.assignableEmployees.length === 0) {
        this.employeesLoading = true
        collectionApi.getEmployees(employees => {
          this.assignableEmployees = employees
          this.employeesLoading = false
        })
      }
    }
  },

  methods: {
    publish() {
      this.apiCallPending = true
      this.$store.dispatch('shifts/bulkEdit',
        {
          shiftIDs: this.shifts.map((s) => s.id),
          params: { approved: true },
        }
      )
      .finally((f) => { this.apiCallPending = false })
    },
    unpublish() {
      this.apiCallPending = true
      this.$store.dispatch('shifts/bulkEdit',
        {
          shiftIDs: this.shifts.map((s) => s.id),
          params: { approved: false },
        }
      )
      .finally((f) => { this.apiCallPending = false })
    },

    assignEmployee() {
      if (!this.assignedEmployee) {
        return
      }
      this.apiCallPending = true
      this.$store.dispatch('shifts/bulkEdit',
        {
          shiftIDs: this.shifts.map((s) => s.id),
          params: { user_id: this.assignedEmployee },
        }
      )
      .finally((f) => {
        this.apiCallPending = false
        this.assignableEmployees = null
        this.bulkAssignDialog = false
      })
    },

    unassignEmployee() {
      this.apiCallPending = true
      this.$store.dispatch('shifts/bulkEdit',
        {
          shiftIDs: this.shifts.map((s) => s.id),
          params: { user_id: null },
        }
      )
      .finally((f) => {
        this.apiCallPending = false
      })
    },

  },
}
</script>
